import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home-page-bottom-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-5fc92f0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bottom-section__icon",
  alt: "icon"
}, null, -1))
const _hoisted_3 = { class: "bottom-section__info" }
const _hoisted_4 = { class: "bottom-section__title" }
const _hoisted_5 = { class: "bottom-section__sub" }

import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomSection',
  setup(__props) {

const { t } = useI18n();

const router = useRouter();

const handleClick = () => {
  router.push({ name: 'Pricing' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('page_home_bottom_section_title')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('page_home_bottom_section_subtitle')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "bottom-section__btn btn btn--prim",
        "data-test": "payment-section-action-btn",
        onClick: handleClick
      }, _toDisplayString(_unref(t)('form_button_upgrade')), 1)
    ])
  ]))
}
}

})